
import * as  XLSX from "xlsx";
const xlsx = XLSX

export default xlsx